import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughAnnouncementProps = {
  node: ConversationFlowAuditLogEntry<'ANNOUNCEMENT_NODE_VISITED'>;
};

export function RoutedThroughAnnouncement({
  node,
}: RoutedThroughAnnouncementProps): JSX.Element {
  return (
    <>
      Audio message · <strong>{node.label}</strong> is played
    </>
  );
}
